import styled from 'styled-components'
import ExternalLink from '../external-link'

export const RegionsMenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`

export const RegionsMenuHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    border-bottom: 0.0625rem solid #e0e0e0;
`

export const RegionsMenuBackButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;

    svg {
        width: 1rem;
        height: 1rem;
    }
`

export const RegionsMenuTitle = styled.h2`
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0;
    flex: 1;
`

export const RegionCountryItemHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 0.0625rem solid #f0f0f0;
`

export const RegionCountryNameLink = styled(ExternalLink)`
    display: flex;
    align-items: center;
    flex: 1;
    padding: 1rem;
    text-decoration: none;
    color: inherit;
    transition: background-color 0.2s ease;
    cursor: pointer;

    &:hover {
        background-color: #f5f5f5;
    }
`

export const RegionCountryToggle = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    background: none;
    border: none;
    padding: 1rem 2rem 1rem 1rem; /* keep ~2rem gap on the right */
    margin-left: auto; /* push to the far right */
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #f5f5f5;
    }
`

export const RegionCountryName = styled.span`
    font-size: 0.95rem;
    font-weight: 500;
    text-align: left;
    flex: 1;
`

interface RegionCountryChevronProps {
    isExpanded: boolean
}

export const RegionCountryChevron = styled.img<RegionCountryChevronProps>`
    width: 1rem;
    height: 1rem;
    transition: transform 0.3s ease;
    transform: ${props => (props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
    flex-shrink: 0;
`

export const RegionCountryList = styled.div`
    display: flex;
    flex-direction: column;
    animation: slideDown 0.2s ease-in-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            max-height: 0;
        }
        to {
            opacity: 1;
            max-height: 62.5rem;
        }
    }
`

export const RegionCountryBlock = styled.div`
    display: block;
    width: 100%;
`

export const RegionItem = styled.div`
    display: flex;
    width: 100%;
`

export const RegionItemLink = styled(ExternalLink)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem 0.75rem 2rem;
    text-decoration: none;
    color: inherit;
    border-bottom: 0.0625rem solid #e0e0e0;
    transition: background-color 0.2s ease;
    width: 100%;
`

export const RegionItemText = styled.span`
    font-size: 0.9rem;
    flex: 1;
    color: #6f6f6f;
`

export const IconImage = styled.img`
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    color: #6f6f6f;
`
